import { getAccountBalance } from '@/services/balance.service';
import { saveSessionLog } from '@/services/user.service';

export const UserModule = {
    state: () => ({
        balance: 0,
        promoCredit: [],
        isLoggedSession: false,
    }),
    mutations: {
        setBalance(state, balance) {
            state.balance = balance;
        },
        setPromoCredit(state, credit) {
            state.promoCredit = credit;
        },
        setLoggedSession(state, data) {
            state.isLoggedSession = data;
        },
        resetBalance(state) {
            state.balance = 0;
        },
    },
    actions: {
        async fetchBalance({ commit }) {
            const { data } = await getAccountBalance();
            commit('setBalance', data);
        },
        async fetchPromoCredit({ commit }) {
            if (this.$auth.loggedIn) {
                commit('setPromoCredit', []);
                const {
                    data: { totalPromo },
                } = await getAccountBalance();
                commit('setPromoCredit', totalPromo);
            }
        },
        logSession({ state, commit }) {
            if (!state.isLoggedSession) {
                saveSessionLog().then(() => {
                    commit('setLoggedSession', true);
                });
            }
        },
    },
    getters: {
        balance(state) {
            return state.balance || 0;
        },
        promoCredit(state) {
            return state.balance || 0;
        },
    },
    namespaced: true,
};
